// const apiUrl = 'https://oc-f-service.onrender.com';
const apiUrl = `https://app-wjkwusgmha-el.a.run.app`;
// const apiUrl = "http://localhost:5001"
export default apiUrl;